import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import React, { useState } from "react";
import { CardFunction, TypographyText, useScreenSize } from "../Reuse/Reuse";
import img1 from "../Assets/5.jpg";
import img2 from "../Assets/7.jpg";
import img3 from "../Assets/6.jpg";
import img4 from "../Assets/team6.jpg";
import sr from "../Assets/sr.jpg";
const Leadership = () => {
  const theme = useTheme(); // Get the theme object
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [readMore, setReadMore] = useState(Array(Data.length).fill(false));
  const matches2 = useScreenSize();
  const handleReadMoreToggle = (index) => {
    const updatedReadMore = [...readMore];
    updatedReadMore[index] = !updatedReadMore[index];
    setReadMore(updatedReadMore);
  };
  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        id="leadership"
        sx={{
          position: "relative",
          width: "100%",
          paddingTop: isSmallScreen ? "12%" : "100px",
          paddingLeft: "5%",
          paddingRight: "5%",
          paddingBottom: "5%",
          // backgroundImage:
            // "url(https://tebewebe.online/pharamedic/wp-content/uploads/sites/40/2023/10/shelves-with-medications-at-a-modern-pharmacy-shop.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          margin: 0,
          "& > .MuiGrid-item": {
          paddingLeft: 0, // Remove padding-left
        },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,

            // backgroundColor: "rgba(19, 43, 44, 0.9)",
            zIndex: 1,
          }}
        />
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{ zIndex: 2 }}
          data-aos="fade-up"
          data-aos-anchor="#example-anchor"
          data-aos-offset="500"
          data-aos-duration="100"

        >
          <TypographyText
            Typography="Leadership Team"
            variant={matches2 ? "h4" : "h5"}
            // color="white"
            textAlign="center"
          />
        </Grid>
        <Grid item xs={12} lg={12} md={12} sm={12} sx={{
          zIndex: 2,
       
          "& > .MuiGrid-item": {
            paddingLeft: 0, // Remove padding-left
          },
         }}>
          <Grid
            container
            spacing={2}
            sx={{
              margin: 0,
              width: "100%",
              display: "flex",

              justifyContent: "center",
              // height:'100%'

            }}
          >
            {Data.map((data, index) => {
            const sentences = data.txt1.split(".");
            const firstSentence = sentences[0] + ".";
              const remainingText = sentences.slice(1).join(".");
              
              
                return (
              <Grid
                item
                xs={12}
                md={6}
                lg={2}
                sm={6}
                key={index}
                sx={{
                  zIndex: 2,
  }}     data-aos="fade-left" 
              >
                <Card
                  sx={{
backgroundColor: "rgba(19, 43, 44, 0.9)",

                    //  backgroundColor: "rgba(255, 255, 255, 0.1)",
                    // display: !isSmallScreen ? "flex" : "centre",
                    borderRadius: "20px",height:'100%'
                  }}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={data.image}
                    alt={data.txt}
                    sx={{
                      objectFit: !isSmallScreen ? "contain" : "contain;",
                    }}
                  />
                  <CardContent>
                    <TypographyText
                      Typography={data.txt}
                      fontSize={"1.5rem"}
                      textAlign="center"
                      color="white"
                    />
                    {/* <TypographyText
                      Typography={data.txt1}
                      fontSize={".9rem"}
                      textAlign="left"
                      color="white"
                    /> */}
  <TypographyText
                        Typography={firstSentence}
                        fontSize={".9rem"}
                        textAlign="left"
                        color="white"
                      />
{readMore[index] && (
                        <TypographyText
                          Typography={remainingText}
                          fontSize={".9rem"}
                          textAlign="left"
                          color="white"
                        />
                      )}
                      <Button
                        onClick={() => handleReadMoreToggle(index)}
                        sx={{ color: "white", textTransform: "none", mt: 1 }}
                      >
                        {readMore[index] ? "Read Less" : "Read More"}
                      </Button>
                  </CardContent>
                </Card>
              </Grid>
           );
          })}    
          </Grid>
        </Grid>
        
      </Grid>
    </React.Fragment>
  );
};

export default Leadership;
const Data = [
  {
    image: img1,
    txt: "Rakesh Nair",
    txt1: "The CEO of Vell Biologics has over 25 years of experience, having leadership roles at Novo Nordisk,Dr. Reddy's, and Ranbaxy. He successfully grew Novo Nordisk's Rare Disease business in India and the UAE from scratch to over $15.5M, bringing critical leadership to Vell Biologics' vision and growth.",
  },

  {
    image: img2,
    txt: "Ashok Rao Bommena",
    txt1: "Co-Promoter and Chief Business Officer of Vell Biologics, has 30+ years of pharmaceutical experience, including 18+ years in leadership roles. As a former Novo Nordisk India Board Director, he drove significant market growth. Ashok will provide critical guidance and leadership to scale Vell Bio’s operations and achieve its business goals",
  },
  {
    image: img3,
    txt: "Sridhar N",
    txt1: "Co-Promoter and Head of Access & Government Affairs at Vell Bio, brings over 20 years of pharmaceutical experience. His expertise in sales, market access, and knowledge of the Indian market, along with his track record in business growth, is crucial for VellBio's market penetration and government affairs strategs",
  },
  {
    image: sr,
    txt: "Jay Kaushik",
    txt1: "Chief Mentor, Angel Investor | Serial Entrepreneur | Healthcare Specialist\nWith 30+ years in healthcare, Jay has driven success in sales, strategy, and business development across diverse sectors. He built and scaled a cosmetic dermatology company, acquired by Sequoia Capital, and now serves as the driving force and chief mentor for Vell Biologics, steering its growth and vision."
  },
  {
    image: img4,
    txt: "Dr Anil Shinde",
    txt1: "Scientific Advisor , with 30+ years of experience, has excelled in clinical research, regulatory affairs, quality, and pharmacovigilance. Formerly the CMRQ Director at Novo Nordisk, he now spearheads Vell Biologics’ medical and regulatory strategy, ensuring quality and compliance to drive growth across diverse therapeutic areas.",
  },
];
